"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    imagePreview: 'Preview'
  },
  es: {
    imagePreview: 'Vista previa'
  },
  fr: {
    imagePreview: 'Aperçu'
  },
  de: {
    imagePreview: 'Vorschau'
  }
};
exports["default"] = _default;